import { Address, Garage } from '@1po/1po-bff-fe-spec/generated/garage/Garage';

export const getFirstValidAddress = (garage: Garage): Address | undefined =>
  garage.addresses?.find((address) => address.type === 'primary') ?? garage.addresses?.[0];

export const formatAddress = (address?: Address): string =>
  address ? [address.address1, address.address2, address.address3, address.address4].filter(Boolean).join(' ') : '';
